import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PricingButtonProps {
  onSignInClick: () => void;
  isAuthenticated: boolean;
  interval: 'monthly' | 'yearly';
}

export default function PricingButton({ onSignInClick, isAuthenticated, interval }: PricingButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!isAuthenticated) {
      onSignInClick();
      return;
    }

    // Navigate to checkout with plan preference
    navigate(`/checkout?interval=${interval}`);
  };

  return (
    <div className="space-y-2">
      <button
        onClick={handleClick}
        className="w-full bg-indigo-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        {isAuthenticated ? `Subscribe ${interval === 'yearly' ? 'Yearly' : 'Monthly'}` : 'Sign in to Subscribe'}
      </button>
    </div>
  );
}